const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20event%20with%20dramatic%20spotlight%20and%20paparazzi%20cameras%20flashing%2C%20luxurious%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20and%20crimson%20lighting%2C%20editorial%20photography%2C%20no%20recognizable%20faces&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '深度扒皮',
    title: '某顶流男星被曝隐婚三年，妻子身份成谜',
    excerpt: '据知情人士透露，该男星早在三年前就已秘密领证，对象为圈外人士。粉丝后援会连夜发声明回应...',
    meta: '2.3 万围观 · 6 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Two%20luxurious%20microphones%20on%20a%20dark%20stage%20with%20dramatic%20crimson%20and%20gold%20spotlight%2C%20theatrical%20drama%20atmosphere%2C%20tension%20and%20conflict%20vibe%2C%20cinematic%20lighting%2C%20no%20people&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '网红大战',
    title: '两大千万粉网红直播间互撕，现场连线对质',
    excerpt: '抖音头部带货主播疑似因供应链纠纷公开翻脸，直播间在线人数一度突破 80 万，弹幕刷屏到服务器卡顿...',
    meta: '5.1 万围观 · 3 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20award%20ceremony%20hall%20with%20empty%20seats%20and%20a%20single%20spotlight%20on%20a%20fallen%20trophy%2C%20dramatic%20mood%2C%20cinematic%20composition%2C%20warm%20amber%20and%20crimson%20accents%2C%20mysterious%20atmosphere&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '娱乐圈地震',
    title: '某综艺节目录制现场爆发激烈冲突',
    excerpt: '据现场观众爆料，两位常驻嘉宾在最新一期录制中因观点不合当场翻脸，导演组紧急暂停录制进行调解...',
    meta: '3.8 万围观 · 8 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20storefront%20at%20night%20with%20reflection%20of%20city%20lights%2C%20elegant%20shopping%20bags%20scattered%2C%20dramatic%20noir%20aesthetic%2C%20glamorous%20yet%20mysterious%20vibe%2C%20high%20contrast%20lighting%2C%20no%20people&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '时尚圈大瓜',
    title: '某奢侈品牌代言人突遭解约，赔偿金或超千万',
    excerpt: '品牌方凌晨发布声明宣布终止合作，据传与代言人近期负面新闻有关。圈内人士分析这是品牌危机公关的极限操作...',
    meta: '1.9 万围观 · 12 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20of%20a%20fashion%20show%20with%20scattered%20designer%20dresses%2C%20mirrors%2C%20and%20warm%20crimson%20lighting%2C%20chaos%20and%20tension%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20no%20recognizable%20people&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '热搜追踪',
    title: '微博热搜前十大换血：吃瓜群众的狂欢日',
    excerpt: '24 小时内微博热搜榜前十名中有七条涉及明星八卦，被网友戏称为内娱吃瓜日。多条话题阅读量破亿...',
    meta: '8.6 万围观 · 1 小时前',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">焦点深扒</h2>
            <p className="mt-2 text-sm text-foreground-600">本周最受关注的深度扒皮专题，一挖到底</p>
          </div>
          <a href="#index" className="hidden md:flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看全部专题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.slice(0, 2).map((item, i) => (
            <article
              key={i}
              className="lg:col-span-2 group cursor-pointer bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/50 transition-all duration-300"
            >
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full min-h-[240px] object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-6 flex flex-col justify-center">
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.excerpt}</p>
                  <span className="mt-4 text-xs text-foreground-500">{item.meta}</span>
                </div>
              </div>
            </article>
          ))}

          {carouselItems.slice(2).map((item, i) => (
            <article
              key={i + 2}
              className="group cursor-pointer bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/50 transition-all duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed flex-1">{item.excerpt}</p>
                <span className="mt-3 text-xs text-foreground-500">{item.meta}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 text-center md:hidden">
          <a href="#index" className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer">
            查看全部专题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}